/** Sort by createdAt descending (newest first). */
export function sortByNewestFirst(items) {
    if (!Array.isArray(items) || items.length === 0) return items;
    return [...items].sort((a, b) => {
        const ta = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
        const tb = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
        return tb - ta;
    });
}

